import React, { Component } from "react";
import { Skeleton, Icon, Input, Modal, message, Spin, Button } from "antd";
import "./index.scss";
import AudioTag from "../../../Common/AudioTag";


import { ReactComponent as VideoIcon } from "../../../../../assets/images/icons/video-play.svg";

import { ReactComponent as ImgEye } from "../../../../../assets/images/icons/image-eye.svg";
import { ReactComponent as DownloadBG } from "../../../../../assets/images/icons/download-bg.svg";
import ShowImageModal from "../ShowImageModal";

class NdrImagemodal extends Component {
  state = {
    loading: true,
    image11: [],
    showMediaModal: {
      visible: false,
      data: [],
    },
    showImageModal: {
      visible: false,
      index: 0,
      files: [],
    },
  };

  // componentDidMount() {
  //   let arr = [];
  //   this.props.showMediaModal.data.map((image) => {
  //     axios({
  //       url: process.env.REACT_APP_API_URL + "/user/show_doc",
  //       method: "post",
  //       responseType: "blob",
  //       withCredentials: true,

  //       data: {
  //         doc: image,
  //         type: "ndr_escalation",
  //       },
  //     })
  //       .then((res) => {
  //         arr.push(URL.createObjectURL(res.data));
  //         this.setState({ image11: arr });
  //       })
  //       .catch((e) => {
  //         this.setState({
  //           loading: false,
  //           imageloading: false,
  //         });
  //         message.warning(e.message);
  //       });
  //   });
  // }

  // this function used for show  big images
  toggleShowImageModal(i = 0, files = []) {
    this.setState({
      showImageModal: {
        visible: !this.state.showImageModal.visible,
        index: i,
        files: files,
      },
    });
  }

  render() {
    let mediaAttachments = this.props.showMediaModal.data;
    const images = this.props.showMediaModal.data.filter(
      (file) => file.filetype === "image"
    );
    const audio = this.props.showMediaModal.data.filter(
      (file) => file.filetype === "audio"
    );
    const video = this.props.showMediaModal.data.filter(
      (file) => file.filetype === "video"
    );

    const PageWrapper = (children) => (
      <div className="ndr-escalation">
        {children}

        <Modal
          title={
            <div className="ndr-escalation-modal-title">
              <h1>NDR Escalation Media</h1>
              <div className="line" />
              <span>VF Order ID: {this.props.showMediaModal.vfId}</span>
              <div className="line" />
              <span>AWB: {this.props.showMediaModal.awb}</span>
            </div>
          }
          className="view-media-modal"
          visible={this.props.visible}
          onCancel={() => this.props.toggleModal()}
          footer={
            <div>
              <Button onClick={() => this.props.toggleModal()}>
                Close Window
              </Button>
            </div>
          }
          width={672}
          maskClosable={true}
        >
          <div className="media-attachments">
            {mediaAttachments && mediaAttachments.length ? (
              // audio media
              <>
                {!!audio && !!audio.length ? (
                  <div className="audio-container">
                    <p>Uploaded Audio:</p>
                    <div className="audio-wraper-all">
                      {audio.map((image, i) => {
                        return <AudioTag src={image.file} />;
                      })}
                    </div>
                  </div>
                ) : null}{" "}
                {/* images media */}
                {!!images && !!images.length ? (
                  <div className="images-container">
                    <p>Uploaded Images:</p>
                    <div className="image-div-wraper">
                      {images.map((image, i) => {
                        return (
                          <div className="img-div">
                            <img src={image.file} alt="Not found" />
                            <Icon
                              className="eye-icon"
                              key={i}
                              onClick={() =>
                                this.toggleShowImageModal(i, images)
                              }
                              component={ImgEye}
                            />
                            <a
                              className="download-icon"
                              href={
                                `${process.env.REACT_APP_API_URL}` +
                                `/products/download_product_media?url=` +
                                `${image.file}`
                              }
                            >
                              <Icon component={DownloadBG} />
                            </a>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : null}
                {/* video media */}
                {!!video && !!video.length ? (
                  <div className="videos-container">
                    <p>Uploaded Videos:</p>
                    <div className="video-div-wraper">
                      {video.map((vid, i) => {
                        return (
                          <div className="video-div">
                            <video src={vid.file} />

                            <a
                              className="download-icon"
                              href={
                                `${process.env.REACT_APP_API_URL}` +
                                `/products/download_product_media?url=` +
                                `${vid.file}`
                              }
                            >
                              <Icon component={DownloadBG} />
                            </a>
                            <Icon
                              className="video-icon"
                              key={i}
                              onClick={() =>
                                this.toggleShowImageModal(i, video)
                              }
                              component={VideoIcon}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : null}
              </>
            ) : (
              <div className="no-found">No Media Found!</div>
            )}
          </div>

          <ShowImageModal
            toggleShowImageModal={() => this.toggleShowImageModal()}
            visible={this.state.showImageModal.visible}
            files={this.state.showImageModal.files}
            defaultIndex={this.state.showImageModal.index}
          />
        </Modal>
      </div>
    );

    if (this.state.loading) {
      return PageWrapper(
        <div style={{ marginBottom: "30px" }}>{/* <Skeleton active /> */}</div>
      );
    }
  }
}

export default NdrImagemodal;
